import { Suspense } from 'react';

import { autoFormaliseOffers } from '@api/autoFormaliseOffers';
import IwRedirect from '@iwRouter/IwRedirect';
import { useQuery } from '@tanstack/react-query';

import { Approved } from './Approved/Approved';
import { DecisionLoading } from './DecisionLoading';
import { Declined } from './Declined';
import { ErrorBoundary } from '../../../../errorBoundary/ErrorBoundary';
import { useStateKey } from '../../../../iwQueryClient/useStateKey';
import FallbackErrorModal from '../../../modals/fallbackErrorModal/FallbackErrorModal';
import { ApplicationPendingView } from '../../../myOffers/pendingView/applicationPendingView/ApplicationPendingView';
import { BackToDashboard } from '../../BackToDashboard';

export const Decision = ({ accountId }: { accountId: string }) => {
    return (
        <ErrorBoundary fallback={() => <FallbackErrorModal />}>
            <Suspense fallback={<DecisionLoading />}>
                <AutoFormalisationResult accountId={accountId} />
            </Suspense>
        </ErrorBoundary>
    );
};

const AutoFormalisationResult = ({ accountId }: { accountId: string }) => {
    const stateKey = useStateKey();
    const { data } = useQuery({
        queryFn: async () => await autoFormaliseOffers({ stateKey }),
        queryKey: ['autoFormaliseOffers', stateKey],
        suspense: true
    });

    if (!data) throw new Error('No data from autoFormaliseOffers');

    switch (data.result) {
        case 'FORMALISED':
            return (
                <>
                    <BackToDashboard />
                    <Approved accountId={accountId} />
                </>
            );
        case 'DECLINED':
            return (
                <div className="mx-auto max-w-xl">
                    <BackToDashboard />
                    <Declined />
                </div>
            );
        case 'DOCS_REQUIRED':
            return <IwRedirect pathname="/apply-flexi-loan/" />;
        case 'DOCS_COMPLETE':
            return (
                <div data-testid="application-pending-view">
                    <ApplicationPendingView />
                </div>
            );
        default:
            throw new Error('Unknown result from autoFormaliseOffers');
    }
};
